import React from 'react'
import './alert.css'
import ProfileNavbar from '../../../../components/Profile-navbar/profile-navbar'
import { Link } from 'react-router-dom'
import { Container,Card, Button } from 'react-bootstrap'

const JobAlert = () => {
  return (
    <div>
      <ProfileNavbar/>
      <Container fluid className='p-5 pb-5 align-items-center' style={{height: '600px'}}>
      <Card className='p-2 my-5 mb-5 mx-md-5 mx-2' style={{background: '#ccdff04d'}}>
                  
                  <Card.Body >
                    <Card.Title>
                    <h3 className='alert-header'>Your Job Alerts</h3>
                    </Card.Title>
                    <div className='alert-line'></div>
                    <Card.Text className='d-md-flex justify-content-between align-items-center' >
                    <p className='alert-header'>Get notified when new jobs match your search</p>
            <button className='btn-1 btn-1-primary alert-btn'>Create Job Alert</button>
                    </Card.Text>
                  </Card.Body>

                </Card>
      </Container>
      
    </div>
  )
}

export default JobAlert
